
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Calendar from 'vux/src/components/calendar/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
Calendar,
Datetime
},
name: 'singleWorkExp',
data () {
return {
company: '',
starttime: '',
endtime: '',
title: '',
endDate: ''
}
},
methods: {
change () {
if (this.endtime === '至今') {
var date = new Date()
var seperator1 = '-'
var year = date.getFullYear()
var month = date.getMonth() + 1
var strDate = date.getDate()
if (month >= 1 && month <= 9) {
month = '0' + month
}
if (strDate >= 0 && strDate <= 9) {
strDate = '0' + strDate
}
var currentdate = year + seperator1 + month + seperator1 + strDate
this.endDate = currentdate
} else {
this.endDate = this.endtime
}
},
addExp () {
if (this.$refs.input1.valid && this.$refs.input2.valid && this.company && this.starttime && this.endtime && this.title) {
var exp = {
'company': this.company,
'starttime': this.starttime,
'endtime': this.endtime,
'title': this.title
}
let expertdata = localStorage.getItem('expertdata')
if (expertdata != null) {
var data = JSON.parse(expertdata)
if (data.experience === null) {
data.experience = []
}
data.experience.push(exp)
expertdata = JSON.stringify(data)
console.log(expertdata)
localStorage.setItem('expertdata', expertdata)
}
this.$router.push({name: 'workExp'})
} else {
if (!(this.$refs.input1.valid && this.$refs.input2.valid)) {
this.$vux.alert.show({
title: '',
content: '输入信息有误'
})
} else {
this.$vux.alert.show({
title: '',
content: '输入信息不完整，请补全后再提交'
})
}
}
},
setToNow () {
this.endtime = '至今'
}
},
created () {
var date = new Date()
var seperator1 = '-'
var year = date.getFullYear()
var month = date.getMonth() + 1
var strDate = date.getDate()
if (month >= 1 && month <= 9) {
month = '0' + month
}
if (strDate >= 0 && strDate <= 9) {
strDate = '0' + strDate
}
var currentdate = year + seperator1 + month + seperator1 + strDate
this.endDate = currentdate

}
}



// WEBPACK FOOTER //
// ./src/components/singleWorkExp.vue